import en from './locale/en';

// All languages removed except for English
export default {
  en,
};
